import {useEffect} from 'react';

import {DialogContent, DialogActions} from '@mui/material';

import {EXPORT_FORMATS} from '../../../../const';
import useBudget from '../../../../hooks/providers/useBudget';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';
import BudgetsSelect from '../BudgetsSelect/BudgetsSelect';

const ExportBudgetModal = () => {
  const {isExportBudgetModalOpen: isOpen, setIsExportBudgetModalOpen: setIsOpen, exportBudgetToFile, selectedBudget: budgetName, setSelectedBudget} = useBudget();

  const canSubmit = budgetName;

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedBudget(null);
    }
  }, [isOpen]);

  return (
    <BaseModal onClose={closeModal} open={isOpen} title="Exporter un budget">
      <DialogContent>
        <BudgetsSelect onSelect={setSelectedBudget} />
      </DialogContent>

      <DialogActions sx={{justifyContent: 'center'}}>
        <Button variant="outlined" color="primary" onClick={closeModal}>
          Fermer
        </Button>
        <Button
          disabled={!canSubmit}
          variant="contained"
          color="secondary"
          onClick={() => {
            closeModal();
            exportBudgetToFile(EXPORT_FORMATS.XLSX);
          }}
        >
          Exporter
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

export default ExportBudgetModal;
